import "react-responsive-carousel/lib/styles/carousel.min.css";
import Button from "@mui/material/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import { T } from "react-translator-component";
import { useSelector } from "react-redux";
import {
  loginWithToken,
  reset as resetUserStoreInfo,
} from "../redux/Reducers/userAuthReducer";
import { reset as resetPostReportsStore } from "../redux/Reducers/postReportsReducer";
import { reset as resetBlockListStore } from "../redux/Reducers/blocksReducer";
import { useAppDispatch } from "../redux/store";
import LoadingModal from "../components/LoadingModal";
import setAuthorizationToken from "../services/axios-util/set-authorization-token";
import setAuthToken from "../services/axios-util/set-auth-token";
import userAuth from "../util/auth-util";
import { styles } from "./styles";

export default function IntroPage() {
  const [queryParameters] = useSearchParams();
  const navigate = useNavigate();

  const { isLoading, user, isError } = useSelector(
    (state: any) => state.userAuth
  );

  const [show, setShow] = useState<boolean>(false);
  const [userReset, setUserReset] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!queryParameters || !dispatch) return

    // ログイン後に不要な情報が残るため削除
    dispatch(resetUserStoreInfo())
    dispatch(resetPostReportsStore())
    dispatch(resetBlockListStore())

    setAuthToken("__");

    const session_id = queryParameters.get("session_id");

    if (session_id) {
      setAuthorizationToken(session_id);
      dispatch(loginWithToken(session_id));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParameters]);

  useEffect(() => {
    // storeのuser情報がリセットされたらフラグを立てる
    if (!user?.auth_token) setUserReset(true)
  }, [user]);

  useEffect(() => {
    if (!navigate || !queryParameters || !userReset || !user?.auth_token) {
      return
    }

    const session_id = queryParameters.get("session_id");

    userAuth.loginUser(user);
    if (user.auth_token) {
      if (session_id === null) {
        setAuthorizationToken(user.auth_token);
      }

      if (user.tutorial_completed_at) {
        navigate("/home");
      } else {
        setShow(true);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, queryParameters, userReset]);

  useEffect(() => {
    if (isError) {
      alert(T("api_unknown_error"));
    }
  }, [isError]);

  const SLIDER = [
    require("../assets/sliderimages/new1.png"),
    require("../assets/sliderimages/new2.png"),
    require("../assets/sliderimages/new3.png"),
    require("../assets/sliderimages/new4.png"),
    require("../assets/sliderimages/new5.png"),
  ];

  const [slide, setSlide] = useState<number>(0);

  const onNext = () => {
    if (slide < SLIDER.length) {
      setSlide(slide + 1);
    }
    if (slide === 4) {
      navigate("/home");
    }
  };

  return (
    <div style={styles.introContainer}>
      <LoadingModal visible={isLoading} />

      {show ? (
        <>
          <Carousel
            showStatus={false}
            swipeable
            showThumbs={false}
            selectedItem={slide}
            onChange={(index) => setSlide(index)}
          >
            {SLIDER.map((item, index) => (
              <div style={styles.introSliderSec} key={index}>
                <img style={styles.introSliderImg} src={item} alt="" />
              </div>
            ))}
          </Carousel>
          <div style={styles.introSliderBtnSec}>
            {user?.auth_token && user?.id && (
              <Button
                onClick={onNext}
                style={styles.introSliderBtn}
                size={"large"}
                variant="contained"
                endIcon={<FontAwesomeIcon icon={faChevronRight} />}
              >
                {slide === 0 ? (
                  <span style={styles.introSliderNextbtn}>{T("read_turorial")}</span>
                ) : (
                  <span style={styles.introSliderNextbtn}>{T("next")}</span>
                )}
              </Button>
            )}
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
